/**
 * home
 */
 import img_01 from '../../assets/img/home/one/img_01.jpg';
 import img_02 from '../../assets/img/home/one/img_02.jpg';
 import img_03 from '../../assets/img/home/one/img_03.jpg';
 import titlepc from '../../assets/img/home/one/titlepc.svg';
 import titlem from '../../assets/img/home/one/titlem.svg';

 import domesticImg1 from '../../assets/img/home/four/domesticImg1.jpg';
 import domesticImg2 from '../../assets/img/home/four/domesticImg2.jpg';
 import domesticImg3 from '../../assets/img/home/four/domesticImg3.jpg';
 import domesticImg4 from '../../assets/img/home/four/domesticImg4.jpg';


import img1 from '../../assets/img/home/fives/img1.jpg';
import img2 from '../../assets/img/home/fives/img2.jpg';
import img3 from '../../assets/img/home/fives/img3.jpg';
import img4 from '../../assets/img/home/fives/img4.jpg';

import icon1 from '../../assets/img/home/fives/icon/icon1.svg';
import icon2 from '../../assets/img/home/fives/icon/icon2.svg';
import icon3 from '../../assets/img/home/fives/icon/icon3.svg';

import iconm1 from '../../assets/img/home/fives/icon/Iconm1.svg';
import iconm2 from '../../assets/img/home/fives/icon/Iconm2.svg';
import iconm3 from '../../assets/img/home/fives/icon/Iconm3.svg';

/**
 * travelMall
 */

// 国内游
import tm_xiamen from '../../assets/img/travelmall/domesticTour/tm_xiamen.jpg';
import tm_chengdu from '../../assets/img/travelmall/domesticTour/tm_chengdu.jpg';
import tm_beihai from '../../assets/img/travelmall/domesticTour/tm_beihai.jpg';
import tm_wanning from '../../assets/img/travelmall/domesticTour/tm_wanning.jpg';
import tm_mongolia from '../../assets/img/travelmall/domesticTour/tm_mongolia.jpg';
import tm_tibet from '../../assets/img/travelmall/domesticTour/tm_tibet.jpg';

import xiamen01 from '../../assets/img/travelmall/domesticTour/tm_xiamen/xiamen01.jpg';
import xiamen02 from '../../assets/img/travelmall/domesticTour/tm_xiamen/xiamen02.jpg';
import xiamen03 from '../../assets/img/travelmall/domesticTour/tm_xiamen/xiamen03.jpg';

import chengdu01 from '../../assets/img/travelmall/domesticTour/tm_chengdu/chengdu01.jpg';
import chengdu02 from '../../assets/img/travelmall/domesticTour/tm_chengdu/chengdu02.jpg';
import chengdu03 from '../../assets/img/travelmall/domesticTour/tm_chengdu/chengdu03.jpg';

import beihai01 from '../../assets/img/travelmall/domesticTour/tm_beihai/beihai01.jpg';
import beihai02 from '../../assets/img/travelmall/domesticTour/tm_beihai/beihai02.jpg';
import beihai03 from '../../assets/img/travelmall/domesticTour/tm_beihai/beihai03.jpg';

import wanning01 from '../../assets/img/travelmall/domesticTour/tm_wanning/wanning01.jpg';
import wanning02 from '../../assets/img/travelmall/domesticTour/tm_wanning/wanning02.jpg';
import wanning03 from '../../assets/img/travelmall/domesticTour/tm_wanning/wanning03.jpg';

import mongolia01 from '../../assets/img/travelmall/domesticTour/tm_mongolia/mongolia01.jpg';
import mongolia02 from '../../assets/img/travelmall/domesticTour/tm_mongolia/mongolia02.jpg';
import mongolia03 from '../../assets/img/travelmall/domesticTour/tm_mongolia/mongolia03.jpg';

import tibet01 from '../../assets/img/travelmall/domesticTour/tm_tibet/tibet01.jpg';
import tibet02 from '../../assets/img/travelmall/domesticTour/tm_tibet/tibet02.jpg';
import tibet03 from '../../assets/img/travelmall/domesticTour/tm_tibet/tibet03.jpg';



// 境外游
import tm_egypt from '../../assets/img/travelmall/overseasTour/tm_egypt.jpg';
import tm_japan from '../../assets/img/travelmall/overseasTour/tm_japan.jpg';
import tm_finland from '../../assets/img/travelmall/overseasTour/tm_finland.jpg';
import tm_bali from '../../assets/img/travelmall/overseasTour/tm_bali.jpg';
import tm_madagascar from '../../assets/img/travelmall/overseasTour/tm_madagascar.jpg';
import tm_antarctica from '../../assets/img/travelmall/overseasTour/tm_antarctica.jpg';

import egypt01 from '../../assets/img/travelmall/overseasTour/tm_egypt/egypt01.jpg';
import egypt02 from '../../assets/img/travelmall/overseasTour/tm_egypt/egypt02.jpg';
import egypt03 from '../../assets/img/travelmall/overseasTour/tm_egypt/egypt03.jpg';

import japan01 from '../../assets/img/travelmall/overseasTour/tm_japan/japan01.jpg';
import japan02 from '../../assets/img/travelmall/overseasTour/tm_japan/japan02.jpg';
import japan03 from '../../assets/img/travelmall/overseasTour/tm_japan/japan03.jpg';

import finland01 from '../../assets/img/travelmall/overseasTour/tm_finland/finland01.jpg';
import finland02 from '../../assets/img/travelmall/overseasTour/tm_finland/finland02.jpg';
import finland03 from '../../assets/img/travelmall/overseasTour/tm_finland/finland03.jpg';

import bali01 from '../../assets/img/travelmall/overseasTour/tm_bali/bali01.jpg';
import bali02 from '../../assets/img/travelmall/overseasTour/tm_bali/bali02.jpg';
import bali03 from '../../assets/img/travelmall/overseasTour/tm_bali/bali03.jpg';

import madagascar01 from '../../assets/img/travelmall/overseasTour/tm_madagascar/madagascar01.jpg';
import madagascar02 from '../../assets/img/travelmall/overseasTour/tm_madagascar/madagascar02.jpg';
import madagascar03 from '../../assets/img/travelmall/overseasTour/tm_madagascar/madagascar03.jpg';

import antarctica01 from '../../assets/img/travelmall/overseasTour/tm_antarctica/antarctica01.jpg';
import antarctica02 from '../../assets/img/travelmall/overseasTour/tm_antarctica/antarctica02.jpg';
import antarctica03 from '../../assets/img/travelmall/overseasTour/tm_antarctica/antarctica03.jpg';

// 全部服务
import frame_1 from '../../assets/img/public/icons/frame_1.svg';
import frame_2 from '../../assets/img/public/icons/frame_2.svg';
import frame_3 from '../../assets/img/public/icons/frame_3.svg';
import frame_4 from '../../assets/img/public/icons/frame_4.svg';
import frame_5 from '../../assets/img/public/icons/frame_5.svg';
import frame_6 from '../../assets/img/public/icons/frame_6.svg';
import frame_7 from '../../assets/img/public/icons/frame_7.svg';
import frame_8 from '../../assets/img/public/icons/frame_8.svg';

// 主题游
import tm_family from '../../assets/img/travelmall/themeTour/tm_family.jpg';
import tm_honeymoon from '../../assets/img/travelmall/themeTour/tm_honeymoon.jpg';
import tm_island from '../../assets/img/travelmall/themeTour/tm_island.jpg';
import tm_culture from '../../assets/img/travelmall/themeTour/tm_culture.jpg';
import tm_adventure from '../../assets/img/travelmall/themeTour/tm_adventure.jpg';
import tm_luxury from '../../assets/img/travelmall/themeTour/tm_luxury.jpg';

// 公用图标
import cat_1 from '../../assets/img/travelmall/icons/cat_1.svg';
import cat_2 from '../../assets/img/travelmall/icons/cat_2.svg';
import cat_3 from '../../assets/img/travelmall/icons/cat_3.svg';
import cat_4 from '../../assets/img/travelmall/icons/cat_4.svg';
import cat_5 from '../../assets/img/travelmall/icons/cat_5.svg';
import cat_6 from '../../assets/img/travelmall/icons/cat_6.svg';

import markMap from '../../assets/img/public/icons/markMapg.svg';
import markMapw from '../../assets/img/public/icons/markMap.svg';
import basicModal1 from '../../assets/img/travelmall/basicModal/icons/v1.svg';
import basicModal2 from '../../assets/img/travelmall/basicModal/icons/v2.svg';

import serviceIcon_1 from '../../assets/img/travelmall/basicModal/icons/serviceIcon_1.svg';
import serviceIcon_2 from '../../assets/img/travelmall/basicModal/icons/serviceIcon_2.svg';
import serviceIcon_3 from '../../assets/img/travelmall/basicModal/icons/serviceIcon_3.svg';

import pcbg from '../../assets/img/travelmall/basicModal/pcbg.jpg';
import pcbgn from '../../assets/img/travelmall/basicModal/pcbgn.jpg';

import q1 from '../../assets/img/travelmall/basicModal/faqico/q1.svg';
import q2 from '../../assets/img/travelmall/basicModal/faqico/q2.svg';
import q3 from '../../assets/img/travelmall/basicModal/faqico/q3.svg';
import q4 from '../../assets/img/travelmall/basicModal/faqico/q4.svg';
import q5 from '../../assets/img/travelmall/basicModal/faqico/q5.svg';
import q6 from '../../assets/img/travelmall/basicModal/faqico/q6.svg';
import q7 from '../../assets/img/travelmall/basicModal/faqico/q7.svg';


// customTravel
import customizedtravel from '../../assets/img/customtravel/banner/customizedtravel.jpg';
import customizedtravelm from '../../assets/img/customtravel/banner/customizedtravelm.jpg';

import ct_image01 from '../../assets/img/customtravel/imgs/ct_image01.jpg';
import ct_image02 from '../../assets/img/customtravel/imgs/ct_image02.jpg';
import ct_image03 from '../../assets/img/customtravel/imgs/ct_image03.jpg';

import whychoose_bg from '../../assets/img/customtravel/imgs/whychoose_bg.jpg';
import whychoose_bgm from '../../assets/img/customtravel/imgs/whychoose_bgm.jpg';

import customtravelIcon1 from '../../assets/img/customtravel/icons/1.svg';
import customtravelIcon2 from '../../assets/img/customtravel/icons/2.svg';
import customtravelIcon3 from '../../assets/img/customtravel/icons/3.svg';
import customtravelIcon4 from '../../assets/img/customtravel/icons/4.svg';

// aboutUs
import au_image01 from '../../assets/img/aboutUs/imgs/au_image01.jpg';
import au_image02 from '../../assets/img/aboutUs/imgs/au_image02.jpg';
import philosophy_img from '../../assets/img/aboutUs/imgs/philosophy_img.jpg';
import philosophy_imgm from '../../assets/img/aboutUs/imgs/philosophy_imgm.jpg';

import d1Icon from '../../assets/img/travelmall/basicModal/icons/d1.svg';
import d2Icon from '../../assets/img/travelmall/basicModal/icons/d2.svg';

// global config file start
const {
  websiteRecord, // 网站备案/版权
  companyName, // 公司名字
  abbreviation, // 简称->中文
  companyAddress,  // 公司地址->中文
  contactInformation, // 联系方式
} = window.globalConfig;
// global config file end

const enUS = {
  'lang': 'English',
  home: {
    videoDisplayData: [
      {
        id: 1001,
        titlep: titlepc,
        titlem: titlem,
        desc: `Imagine A New World, More Wonderful With You`,
        img: img_01,
      },
     /*  {
        id: 1002,
        titlep: titlepc,
        titlem: titlem,
        desc: `Taste Of Japan, A Comprehensive Overview Of Japanese Customs`,
        img: img_02,
      },
      {
        id: 1003,
        titlep: titlepc,
        titlem: titlem,
        desc: `Dream Glass House Suite, Lying In Bed To Enjoy The Aurora Borealis`,
        img: img_03,
      }, */
    ],
    twoPage: {
      content: {
        title: 'Travel the World and Enjoy What you Want',
        desc: `Established in 2016, ${companyName.fullNameEN} is a professional and comprehensive travel service provider in China. We promote a different vacation concept, providing services including inbound tours, outbound tours, travel customization, hotel booking and other services, travel services. We have a strong competitive advantage in Hong Kong and Macao tours, Southeast Asia outbound tours, Japan and Korea outbound tours, and have been winning praise from customers at home and abroad for our excellent travel quality and honest services.`,
      }
    },
    threePage: {
      serviceAdvantagesData: [
        {
          id: 1001,
          title: 'Service Advantages',
          subTitle: `Field survey: Netflix attractions hit the big disappointment? The gap between the guide and the actual is too big? `,
          desc: `42 countries custom travel routes field survey, focus on mining local cultural life.`
        },
        {
          id: 1002,
          title: 'Service Advantages',
          subTitle: `Travel without worries: language barrier, communication difficulties? Don't know how to deal with unexpected situations?`,
          desc: `7×24 butler service, airline, hotel, security, driver and guide are all available.`
        },
        {
          id: 1003,
          title: 'Service Advantages',
          subTitle: `Personalized: Checking information, reading tips, getting a visa, travel preparation tedious headache?`,
          desc: `Tailor-made itineraries are available to meet your individual needs in different scenarios.`
        },
        {
          id: 1004,
          title: 'Service Advantages',
          subTitle: `Value Experience: Tired of the same old thing? Want a different kind of travel experience?`,
          desc: `Exclusive resources to meet your requirements and exceed your imagination.`
        },
      ]
    },
    fourPage: {
      morepTitle: 'Domestic Selection',
      domesticSelectionData: [
        {
          id: 1001,
          num: 4,
          index: 3,
          title: 'Wannings',
          subTitle: 'The four seasons are warm like spring, and the water is crystal clear like glass',
          img: domesticImg1,
        },
        {
          id: 1002,
          num: 5,
          index: 4,
          title: 'Mongolia',
          subTitle: `Admire the most stunning grassland natural scenery`,
          img: domesticImg2,
        },
        {
          id: 1003,
          num: 6,
          index: 1,
          title: 'Chengdu',
          subTitle: 'Let go of the burden of life and work, and visit the soft and cute giant panda',
          img: domesticImg3,
        },
        {
          id: 1004,
          num: 7,
          index: 5, 
          title: 'Tibet',
          subTitle: `A sacred journey, looking for a different Lhasa`,
          img: domesticImg4,
        },
      ]
    },
    fivesPage: {
      morepTitle: 'Overseas Selection',
      overseasSelectionData: [
        {
          id: 1001,
          title: `Slow travel to Kansai for the first time`,
          subTitle: 'With the modernity of Osaka and the ancient tranquility of Kyoto and Nara',
          // subTitle: 'With the modernity of Osaka and the ancient tranquility of Kyoto and Nara, this itinerary will immerse you in the natural beauty, cuisine and culture of Japan as you travel between cities and ancient cities.',
          address: 'Japan',
          img: img1,
          icon: markMapw,
        },
        {
          id: 1002,
          title: 'Natural beauty',
          subTitle: `Perfect combination with modern city`,
          // subTitle: `You can embark on the fun mecca of Sentosa Island with its endless rides, or head to Orchard Road with its more than 100 shopping malls for a shopping spree. The day and night zoo, located in the northern rainforest, is a popular choice for families. At night, Marina Bay is a great time to take pictures with the landmark Sands Hotel and the Fishtail Statue, and the world's tallest Aviator Ferris wheel offers a panoramic view of the entire Marina Bay.`,
          address: 'Singapore',
          img: img2,
          icon: markMapw,
        },
        {
          id: 1003,
          title: 'Sahara',
          subTitle: `To meet all your longing for the desert`,
          //subTitle: `Half sea, half desert, Morocco has much more beauty than you can imagine, with a stunning coastline stretching for thousands of miles by the Atlantic Ocean and hot air balloons in the colorful old city of Marrakech.In the Sahara Desert off-road vehicle sand rushing, camel riding along the sunset, watching the sunset on the sand dunes, looking up at the starry sky outside the tent, it can meet all your longing for travel.`,
          address: 'Morocco',
          img: img3,
          icon: markMapw,
        },
        {
          id: 1004,
          title: 'Spain',
          subTitle: `Under the bright sun of the Iberian Peninsula`,
          // subTitle: `The passionate flamenco, the brave bullfighters, the dazzling sunshine of Spain. The towering Pyrenees mountains block the cold air from the south of the European continent, and create a unique Spain - flamboyant, passionate and painful.`,
          address: 'Spain',
          img: img4,
          icon: markMapw,
        },
      ]
    },
    sixPage: {
      statisticsInner: {
        since: 'Since 2016 Year,',
        total: '284,301',
        customers: 'customers',
      },
      choose: 'have chosen  Ding Sheng Travel, and the number is still growing ...',
    }
  },
  travelMall: {
    bannerBtnText: 'The Most Beautiful Scenery, Always on the Road',
    domesticTour: {
      title: 'Domestic Tour',
      list: [
        {
          id: 1001,
          title: 'Garden by the Sea',
          people: '/pax',
          address: 'Xiamen',
          days: '5Days',
          group: 'Run to the island',
          total: 'Total 74 people traveled',
          money: '1,699',
          img: tm_xiamen,
          icon: cat_4,
          markMap: markMap,
          content: [
            {
              key: 1001,
              desc: `Classic attractions, Gulangyu Island, Yunshui Ballad Tulou, easy to hit the card! Arranged 1 day stay on the island, fun and not tired!`,
            },
            {
              key: 1002,
              desc: `Xiamen's unique southern Fujian culture makes this city different from other places, from the architectural style, humanities and history to local cuisine, the unique southern Fujian flavor, so you can experience a completely different life atmosphere from the usual, but also let you add more interest in the city.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: xiamen01,
            },
            {
              id: 'B1002',
              img: xiamen02,
            },
            {
              id: 'B1003',
              img: xiamen03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Arrive in Xiamen',
                  },
                  {
                    key: 1002,
                    name: '→',
                  },
                  {
                    key: 1003,
                    name: 'The eighth seafood market',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Arrive in Xiamen',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Yunshui ballad ancient town ',
                  },
                  {
                    key: 1002,
                    name: '→',
                  },
                  {
                    key: 1003,
                    name: 'Huaiyuan building',
                  },
                  {
                    key: 1004,
                    name: '→',
                  },
                  {
                    key: 1005,
                    name: 'And Guilou',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Yunshui ballad ancient town',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Bell and Drum Ropeway',
                  },
                  {
                    key: 1002,
                    name: '→',
                  },
                  {
                    key: 1003,
                    name: 'Nanputuo Temple',
                  },
                  {
                    key: 1004,
                    name: '→',
                  },
                  {
                    key: 1005,
                    name: 'Go to Gulangyu Island',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Bell and Drum Ropeway',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Sunlight Rock',
                  },
                  {
                    key: 1002,
                    name: '→',
                  },
                  {
                    key: 1003,
                    name: 'Peasant Village Garden',
                  },
                  {
                    key: 1004,
                    name: '→',
                  },
                  {
                    key: 1005,
                    name: 'Return',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Sunlight Rock',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
          },
        },
        {
          id: 1002,
          title: 'Panda Baby',
          people: '/pax',
          address: 'Chengdu',
          days: '4Days',
          group: 'Family Parenting',
          total: 'Total 160 people traveled',
          img: tm_chengdu,
          icon: cat_1,
          markMap: markMap,
          money: '1,499',
          content: [
            {
              key: 1001,
              desc: `A must-see for walking children, lazy hours and seeing soft and cute pandas.`,
            },
            {
              key: 1002,
              desc: `Not busy, not arrogant, put down the burden of life and work, in the travel to find their original most beautiful appearance.`,
            },
            {
              key: 1003,
              desc: `The most beautiful time, the best age, the best travel to the most loved ones and family.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: chengdu01,
            },
            {
              id: 'B1002',
              img: chengdu02,
            },
            {
              id: 'B1003',
              img: chengdu03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Arrival in Chengdu',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Chunxi Road',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Taiyang Taikoo Li, Chengdu',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Fanshoe Bookstore',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Arrival in Chengdu',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [ //  →  →  → 
                  {
                    key: 1001,
                    name: 'Chengdu Giant Panda Breeding Base',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Kuanzhai Alley',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Xiaotong Alley',
                  },
                  {
                    key: 1006,
                    name: 'Kui Xing Lou Street',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Chengdu Giant Panda Breeding Base',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Du Fu Cao Tang',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Wuhou Temple',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Jinli',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Du Fu Cao Tang',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Chengdu',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Return',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Chengdu',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1003,
          title: 'Beihai + Weizhou Island',
          people: '/pax',
          address: 'Beihai',
          days: '4Days',
          group: 'Run to the island',
          total: 'Total 35 people traveled',
          img: tm_beihai,
          icon: cat_2,
          markMap: markMap,
          money: '1,499',
          content: [
            {
              key: 1001,
              desc: `Beihai, a city to stay and do not want to leave, feel the sunny beach, a line of sea views to watch the sunset, INS island resort style B&B.`,
            },
            {
              key: 1002,
              desc: `The fine soft white sandy beach is one of the best in the world, the water is crystal clear and the fish are free. At night, you will enjoy the most charming and cleanest starry sky in the world, and taste the best seafood and various fruits.`,
            },
            {
              key: 1003,
              desc: `Here, you will forget all your worries and just have a simple, pure and happy time.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: beihai01,
            },
            {
              id: 'B1002',
              img: beihai02,
            },
            {
              id: 'B1003',
              img: beihai03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Arrival in Beihai',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Beihai Silver Beach Resort',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Beihai Underwater World',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Arrival in Beihai',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Beihai',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Weizhou Island Wucai Beach',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Weizhou Shengtang Catholic Church',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Beihai',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Weizhou Island ',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Dishui Danping',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Weizhou Island ',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Beihai',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Return',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Beihai',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1004,
          title: 'Sunbathing in a warm island',
          people: '/pax',
          address: 'Wanning',
          days: '5Days',
          group: 'Run to the island',
          total: 'Total 35 people traveled',
          img: tm_wanning,
          icon: cat_2,
          markMap: markMap,
          money: '1,999',
          content: [
            {
              key: 1001,
              desc: `It is a place where it is as warm as spring in all seasons and the glassy and crystal clear seawater allows you to do nothing but stare at the sea and gaze at the distance, waiting for sunset and dawn.`,
            },
            {
              key: 1002,
              desc: `You can explore the interesting Young life, master the surfing skills, explore the snorkeling of Kaji Island, the new trendy island resort style. A variety of island activities, parasailing (paragliding), flying fish, motorboat tandem, underwater walking, banana boat, coral reef snorkeling, travel photography, etc., to help you explore the beauty of "heaven on earth"!`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: wanning01,
            },
            {
              id: 'B1002',
              img: wanning02,
            },
            {
              id: 'B1003',
              img: wanning03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Arrive Haikou',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Wanning',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Arrive Haikou',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Surfing in Shimei Bay/Riyue Bay',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Xinglong Tropical Botanical Garden',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Bali Village',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Surfing in Shimei Bay/Riyue Bay',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Shimei Bay Gajing Island',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Shimei Bay Gajing Island',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Phoenix Jiuli Book House ',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Shenzhou Peninsula',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Dongshanling Cultural Tourism Area',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Phoenix Jiuli Book House ',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'Wanning',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Haikou',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Return',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Wanning',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1005,
          title: 'Traveling Tour - Inner Mongolia Grassland Season',
          people: '/pax',
          address: 'Inner Mongolia ',
          days: '6Days',
          group: 'Natural Scenery',
          total: 'Total 35 people traveled',
          img: tm_mongolia,
          icon: cat_3,
          markMap: markMap,
          money: '3,999',
          content: [
            {
              key: 1001,
              desc: `Inner Mongolia Hulunbeier + Manzhouli + Erguner let you play all at once!`,
            },
            {
              key: 1002,
              desc: `Breeze rolls green waves of Hulunbeier, you will enjoy the most charming natural scenery of grassland.`,
            },
            {
              key: 1003,
              desc: `The endless grasslands, the azure sky, the cleanest and most charming starry sky.`,
            },
            {
              key: 1004,
              desc: `The colorful flowers along the way, everywhere is a postcard-like scenery.`,
            },
            {
              key: 1005,
              desc: `There are flocks of cows and sheep, green grass and colorful flowers all over the place.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: mongolia01,
            },
            {
              id: 'B1002',
              img: mongolia02,
            },
            {
              id: 'B1003',
              img: mongolia03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Arrival in Hailar',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Arrival in Hailar',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Hulunbeier Grassland',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Erguna National Wetland Park',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Hulunbeier Grassland',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Hulunbeier Heiheitou Junchi Horse Farm (unlimited horseback riding across the grassland)',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Eji Hometown',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Border Road',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Hulunbeier Heiheitou Junchi Horse Farm (unlimited horseback riding across the grassland)',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Baerhu Mongolian tribe folklore resort scenic spot',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Manzhouli lasso scenic spot',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Manzhouli',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Sino-Soviet Golden Street Walking Street',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Baerhu Mongolian tribe folklore resort scenic spot',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  
                  {
                    key: 1001,
                    name: 'Manzhouli State Gate Scenic Area ',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Hulun Lake',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Hohonor Grassland Tourist Area',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Manzhouli State Gate Scenic Area ',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: 'Hailar',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Return',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Hailar',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1006,
          title: 'Tibet first experience - Linzhi Lhasa',
          people: '/pax',
          address: 'Tibet',
          days: '7Days',
          group: 'Natural Scenery',
          total: 'Total 35 people traveled',
          img: tm_tibet,
          icon: cat_4,
          markMap: markMap,
          money: '3,999',
          content: [
            {
              key: 1001,
              desc: `The south of Tibet, sacred journey, looking for a different Lhasa.`,
            },
            {
              key: 1002,
              desc: `Deep forested valley of the Bassong wrong region and the Grand Canyon region, the country of elves of the cold spruce forest, jasper cut into streams, hanging blue sky waterfalls, cattle and horses in the hidden pastures. A lifetime of unforgettable snow peak sunset.`,
            },
            {
              key: 1003,
              desc: `All the way through the glaciers, lakes, streams, waterfalls, pastures, canyons, primitive forests, grasslands and other different forms of natural wonders of creation.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: tibet01,
            },
            {
              id: 'B1002',
              img: tibet02,
            },
            {
              id: 'B1003',
              img: tibet03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Arrival in Linzhi',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Yarlung Zangbo River',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Sosong Village',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Arrival in Linzhi',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Yarlung Zangbo River',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Sedjira Pass',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Lulang Forest Sea',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Zhaxi Gang Village',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Yarlung Zangbo River',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Linzhi',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Batsontso',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Gala Peach Blossom Village',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Linzhi',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Bassong Tso',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Lhasa',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Bassong Tso',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'Lhasa',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Shannan',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Yamdrok Yomchu',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Lhasa',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: 'Lhasa',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Potala Palace',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Dajokhang Temple',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Barkhor Street',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Lhasa',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: 'Lhasa',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Return',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Lhasa',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
      ],
    },
    overseasTour: {
      title: 'Overseas Tour',
      list: [
        {
          id: 1001,
          title: 'Following the footsteps of the pharaohs to explore the thousand years of history',
          people: '/pax',
          address: 'Egypt',
          days: '7Days',
          group: 'World Treasures',
          total: 'Total 9 people traveled',
          money: '19,999',
          img: tm_egypt,
          icon: cat_4,
          markMap: markMap,
          content: [
            {
              key: 1001,
              desc: `The river of history rolls on through the millennia, and ancient Egypt is one of the most fascinating places in that long history.`,
            },
            {
              key: 1002,
              desc: `Featured Experience.`,
            },
            {
              key: 1003,
              desc: `★Official guided tour inside the pyramids to explore the unsolved mysteries of mankind.`,
            },
            {
              key: 1004,
              desc: `★Enjoy the breathtaking sunset over the Nile River on a windjammer.`,
            },
            {
              key: 1005,
              desc: `★Cruise the ancient city by Luxor's special carriage, close to the real Egyptian life.`,
            },
            {
              key: 1006,
              desc: `★Romantic underwater glass boat cruise, explore the beautiful underwater world.`,
            },
            {
              key: 1007,
              desc: `★Ride the desert motorcycle wild sand rush, enjoy the sunset of Hurghada Desert.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: egypt01,
            },
            {
              id: 'B1002',
              img: egypt02,
            },
            {
              id: 'B1003',
              img: egypt03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Cairo',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Aswan',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Cairo',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Aswan',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Koelnpo',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Aswan',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Edfu',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Edfu',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Luxor',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Hurghada',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Luxor',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'Hurghada',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Hurghada',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: 'Hurghada',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Hurghada',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: 'Hurghada',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Cairo',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Hurghada',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: 'Cairo',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Cairo',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D9',
                address: [
                  {
                    key: 1001,
                    name: 'Cairo',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '送机',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Delivery',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1002,
          title: 'Tour] About Cherry Blossom Season',
          people: '/pax',
          address: 'Japan',
          days: '5Days',
          group: 'Natural Scenery',
          total: 'Total 83 people traveled',
          img: tm_japan,
          icon: cat_1,
          markMap: markMap,
          money: '9,999',
          content: [
            {
              key: 1001,
              desc: `Chasing the most beautiful cherry blossom sanctuary in Kansai, the infinite scenery of the castle building here is still white as snow and spectacular after hundreds of years.`,
            },
            {
              key: 1002,
              desc: `The cherry blossoms and the white castle towers reflect each other, and there is nothing more enchanting and beautiful than this. Enjoy the beautiful scenery, local food, and rich handicraft experience along the way.The night cherry blossom viewing, stargazing and hot spring baths are available in the garden.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: japan01,
            },
            {
              id: 'B1002',
              img: japan02,
            },
            {
              id: 'B1003',
              img: japan03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Fushimi Inari Taisha Shrine ',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Kyoto Nishiki Market',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Saito-cho',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Kamogawa River',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Fushimi Inari Taisha Shrine ',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Kiyomizudera Temple ',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Sanzaka and Nisezaka',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Yasaka Shrine',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Round Hill Park',
                  },
                  {
                    key: 1008,
                    name: ' → ',
                  },
                  {
                    key: 1009,
                    name: 'Gion',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Kiyomizudera Temple ',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Sanjusangendo',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Kinkaku-ji',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Ryoan-ji Temple ',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Kyoto Nijo Castle',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Sanjusangendo',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Ginkaku-ji Temple',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Philosophical Road',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Tachigami Tilt Railroad',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Daigoji Temple',
                  },
                  {
                    key: 1008,
                    name: ' → ',
                  },
                  {
                    key: 1009,
                    name: 'Heian Jingu Shrine',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Ginkaku-ji Temple',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'Sagano Bamboo Forest ',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Nonomiya Shrine',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Tenryuji Temple',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Arashiyama Sagano Sightseeing Train',
                  },
                  {
                    key: 1008,
                    name: ' → ',
                  },
                  {
                    key: 1009,
                    name: 'Watanuki Bridge',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Sagano Bamboo Forest',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1003,
          title: 'Aurora Borealis in a Dream Glass House',
          people: '/pax',
          address: 'Finland',
          days: '9Days',
          group: 'Natural Scenery',
          total: 'Total 17 people traveled',
          img: tm_finland,
          icon: cat_3,
          markMap: markMap,
          money: '19,999',
          content: [
            {
              key: 1001,
              desc: `★Fantasy glass house suite, lie in bed and enjoy the aurora borealis`,
            },
            {
              key: 1002,
              desc: `★Visit the world's only Santa Claus in Santa Claus Village`,
            },
            {
              key: 1003,
              desc: `★Ice and snow fortress in the traditional Finnish smoke sauna`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: finland01,
            },
            {
              id: 'B1002',
              img: finland02,
            },
            {
              id: 'B1003',
              img: finland03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'China',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Helsinki',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'China',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Helsinki',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Helsinki',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Helsinki',
                  },
                  {
                    key: 1008,
                    name: ' → ',
                  },
                  {
                    key: 1009,
                    name: 'Rovaniemi',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Helsinki',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Rovaniemi',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Rovaniemi',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'Rovaniemi',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Kemi',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Rovaniemi',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Rovaniemi',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: 'Rovaniemi',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Saliselka',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Rovaniemi',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: 'Saliselka',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Ivalo',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Saliselka',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: 'Ivalo',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Ivalo',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D9',
                address: [
                  {
                    key: 1001,
                    name: 'Ivalo',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Helsinki',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'China',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Ivalo',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1004,
          title: 'The most beautiful sunset in the world here',
          people: '/pax',
          address: 'Bali',
          days: '5Days',
          group: 'Natural Scenery',
          total: 'Total 52 people traveled',
          img: tm_bali,
          icon: cat_2,
          markMap: markMap,
          money: '6,999',
          content: [
            {
              key: 1001,
              desc: `The clear blue ocean, white sandy beaches, swaying coconut trees, natural and pure ocean and rivers. Escape the crowds, away from the hustle and bustle, and enjoy your own private time, where you will not be disturbed by anything outside.`,
            },
            {
              key: 1002,
              desc: `In addition to the exciting water activities and breathtaking natural scenery, you can also snorkel directly off the private beach or behind the island and experience the incredible marine life and colorful coral.`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: bali01,
            },
            {
              id: 'B1002',
              img: bali02,
            },
            {
              id: 'B1003',
              img: bali03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: `Lover's Cliff `,
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Eagle Square',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Temple of the Sea',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: `Lover's Cliff `,
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Blue Dream Island',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Blue Dream Island',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Ayung River Rafting',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Jimbaran Beach',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Ayung River Rafting',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [

                  {
                    key: 1001,
                    name: 'Holy Spring Temple',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Degrarang Terraces',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: 'Ubud Palace',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: 'Ubud Market',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Holy Spring Temple',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'Sun Department Store',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Sun Department Store',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1005,
          title: `The island forgotten by time, the last Noah's Ark`,
          people: '/pax',
          address: 'Madagascar',
          days: '8Days',
          group: 'Natural Scenery',
          total: 'Total 52 people traveled',
          img: tm_madagascar,
          icon: cat_4,
          markMap: markMap,
          money: '9,999',
          content: [
            {
              key: 1001,
              desc: `★Antsirabe: the mysterious volcanic lake in the city of water`,
            },
            {
              key: 1002,
              desc: `★Murungdawa: Natural beaches, magnificent sunsets, humanistic paradise`,
            },
            {
              key: 1003,
              desc: `★Ondasibe National Park: dancing with lemurs`,
            },
            {
              key: 1004,
              desc: `★Antananarivo: a testimony to the history and humanity of the island of Ma`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: madagascar01,
            },
            {
              id: 'B1002',
              img: madagascar02,
            },
            {
              id: 'B1003',
              img: madagascar03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Pickup From Tananarive Airport',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Pickup From Tananarive Airport',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Tananarive',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Morondava',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Tananarive',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Morondava',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Morondava',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Morondava',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Antsirabe',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Morondava',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'Antsirabe',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Tananarive',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Antsirabe',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: 'Tananarive',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: 'Andasibe',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Tananarive',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: 'Andasibe (Lemur Island and Crocodile Valley)',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Andasibe (Lemur Island and Crocodile Valley)',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: 'Andasibe',
                  },
                  {
                    key: 1001,
                    name: ' → ',
                  },
                  {
                    key: 1001,
                    name: 'Departure From Tananarive Airport',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Andasibe',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1006,
          title: 'Polar Expedition, Visit Penguins',
          people: '/pax',
          address: 'Antarctica',
          days: '12Days',
          group: 'Natural Scenery',
          total: 'Total 12 people traveled',
          img: tm_antarctica,
          icon: cat_4,
          markMap: markMap,
          money: '28,999',
          content: [
            {
              key: 1001,
              desc: `★Cruise in comfort with the Hebridean Sky`,
            },
            {
              key: 1002,
              desc: `★Chinese guide on board for a worry-free Antarctic trip`,
            },
            {
              key: 1003,
              desc: `★Camping in Antarctica with penguin babies`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: antarctica01,
            },
            {
              id: 'B1002',
              img: antarctica02,
            },
            {
              id: 'B1003',
              img: antarctica03,
            },
          ],
          newTravelItinerary: {
            title: 'Trip options',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: 'Ushuaia',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Ushuaia',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: 'Ushuaia embarkation',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Ushuaia embarkation',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: 'Drake Passage',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Drake Passage',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: 'Drake Passage',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Drake Passage',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: 'South Shetland Islands: stop at penguin colony, seal habitat, bird colony and whale active area',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'South Shetland Islands',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: 'South Shetland Islands: stop at penguin colony, seal habitat, bird colony and whale active area',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'South Shetland Islands',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: 'Antarctic Peninsula',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Antarctic Peninsula',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: 'Antarctic Peninsula',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Antarctic Peninsula',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D9',
                address: [
                  {
                    key: 1001,
                    name: 'Antarctic Peninsula',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Antarctic Peninsula',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D10',
                address: [
                  {
                    key: 1001,
                    name: 'Drake Passage',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Drake Passage',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D11',
                address: [
                  {
                    key: 1001,
                    name: 'Drake Passage',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Drake Passage',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch/Dinner',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D12',
                address: [
                  {
                    key: 1001,
                    name: 'Ushuaia',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: 'Ushuaia',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: 'Breakfast/Lunch',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
      ],
    },
    inclusiveAll: {
      title: 'Eight Services, All-Inclusive',
      list: [
        {
          id: 'E001',
          img: frame_1,
          desc: 'Air Ticket Booking',
        },
        {
          id: 'E002',
          img: frame_2,
          desc: 'Accommodation Booking',
        },
        {
          id: 'E003',
          img: frame_3,
          desc: 'Itinerary Design',
        },
        {
          id: 'E004',
          img: frame_4,
          desc: 'Exclusive Road Map',
        },
        {
          id: 'E005',
          img: frame_5,
          desc: 'Travel Visa',
        },
        {
          id: 'E006',
          img: frame_6,
          desc: 'Travel Insuranc',
        },
        {
          id: 'E007',
          img: frame_7,
          desc: 'Travel WIFI',
        },
        {
          id: 'E008',
          img: frame_8,
          desc: 'Golden Car Guide',
        },
      ],
      desc: 'The above items contain information for reference only, custom service options are subject to final confirmation, please contact your travel planner for details.',
    },
    themeTour: {
      title: 'Theme Tour',
      list: [
        {
          id: 1001,
          title: 'Family parenting',
          desc: 'Spend more time with your family and gain a unique vacation experience.',
          img: tm_family,
          icon: cat_1,
        },
        {
          id: 1002,
          title: 'Honeymoon Wedding',
          desc: 'eet all your romantic expectations and reap 100 points of sweetness.',
          img: tm_honeymoon,
          icon: cat_5,
        },
        {
          id: 1003,
          title: 'To The Island',
          desc: 'wander among the islands, dive into the deep sea.',
          img: tm_island,
          icon: cat_2,
        },
        {
          id: 1004,
          title: 'World Treasures',
          desc: 'Walk into the feast of history and culture, feel the changes of the millennium.',
          img: tm_culture,
          icon: cat_4,
        },
        {
          id: 1005,
          title: 'Hunting Adventure',
          desc: 'Feel the vastness and the original meaning of nature.',
          img: tm_adventure,
          icon: cat_3,
        },
        {
          id: 1006,
          title: 'Top Luxury',
          desc: 'The whole top arrangement reception, enjoy the luxury service.',
          img: tm_luxury,
          icon: cat_6,
        },
      ],
    },
    absNavsData: {
      list: [
        {
          id: 'T001',
          jumpName: 'jumpTravelItinerary',
          name: 'Travel Itinerary',
        },
        {
          id: 'T002',
          jumpName: 'jumpPricing',
          name: 'Pricing',
        },
        {
          id: 'T003',
          jumpName: 'jumpCustomizationProcess',
          name: 'Customization Process',
        },
        {
          id: 'T004',
          jumpName: 'jumpFAQ',
          name: 'FAQ',
        },
        {
          id: 'T005',
          jumpName: 'jumpTBookingInstructions',
          name: 'Booking Instructions',
        },
      ],
      enquiry: 'Enquiry',
    },
    pricingData: {
      title: 'Price Content',
      list: [
        {
          id: 'P001',
          img: basicModal1,
          name: 'Fee Inclusion',
          children: [
            {
              id: '1001',
              name: 'Fee Inclusion',
            },
          ],
        },
        {
          id: 'P002',
          img: basicModal1,
          children: [
            {
              id: '1001',
              name: 'Airline Ticket Booking: ',
            },
            {
              id: '1002',
              name: 'Full tax inclusive airline ticket booking',
            },
          ],
        },
        {
          id: 'P003',
          img: basicModal2,
          children: [
            {
              id: '1001',
              name: 'Accommodation Booking',
            },
            {
              id: '1002',
              name: 'Tax inclusive accommodation booking',
            },
          ],
        },
        {
          id: 'P004',
          img: basicModal1,
          children: [
            {
              id: '1001',
              name: 'Services Include',
            },
          ],
        },
      ]
    },
    pricingMainData: [
      {
        title: {
          name: '1、Basic Services',
        },
        list: [
          {
            id: 1001,
            title: 'Travel consultant: ',
            subTitle: 'We provide each customer with an exclusive travel consultant, and the customer can get free consultation for the whole route.',
          },
          {
            id: 1002,
            title: 'Road book: ',
            subTitle: `Each customized travel product comes with an exclusive road book. The road book is a travel guide for your trip abroad, with itinerary, shortest route, car rental procedures, restaurant recommendations, etc. All in the book, solving 99% of the problems during the trip. It is very versatile and private.`,
          },
          {
            id: 1003,
            title: 'Itinerary protection: ',
            subTitle: `Think Travel provides a full travel protection service. When you encounter problems abroad, you can always contact your post-trip protection team or call our 24-hour emergency number.`,
          },
          {
            id: 1004,
            title: 'Itinerary modification: ',
            subTitle: 'You can take the initiative to ask us to modify the accommodation booking, sightseeing, activities and other elements of the product for you, and then deliver the full payment when you are satisfied.',
          },
          {
            id: 1005,
            title: 'Visa: ',
            subTitle: `We can arrange visa for the destination on behalf of our customers who have a passport from the People's Republic of China (please make sure that the passport is still valid for more than six months at the time of travel). If you provide your own visa, the visa fee will be deducted from the customized travel product.`,
          },
          {
            id: 1006,
            title: 'WiFi rental: ',
            subTitle: 'High quality portable WiFi (pick up at the airport)',
          },
          {
            id: 1007,
            title: 'Overseas insurance: ',
            subTitle: 'Short-term travel insurance (subject to the specific itinerary)',
          },
        ],
      },
      {
        title: {
          name: '2、Optional Services',
        },
        list: [
          {
            id: 1001,
            title: '(quoted on a case-by-case basis)',
            subTitle: 'Charter bus (Chinese driver / foreign language driver), multi-person group travel (more than 6 people), GPS rental, shuttle service, overseas wedding, overseas shooting',
          },
        ],
      },
    ],
    expenseDescriptionData: [
      {
        title: {
          name: ' Fee Description',
        },
        list: [
          {
            id: 1001,
            desc: `The starting price for this product is the lowest single rate based on two people traveling in one room. Prices may vary depending on the departure date, the number of travelers, the type of accommodation booked, the flight or transportation and the additional services selected.`,
          },
          {
            id: 1002,
            desc: `The air ticket booking category in this product portfolio is for international round-trip air ticket booking and overseas transportation ticket booking only.`,
          },
          {
            id: 1003,
            desc: `Please note that some countries and cities are subject to city tax, the exact amount of which will be determined at the time of check-in, and will not be collected by our company, but will be paid directly to the front desk of the accommodation booking. It is recommended to keep an appropriate amount of cash to pay the relevant fees.`,
          },
          {
            id: 1004,
            desc: `The booking fee for destination accommodation provided in this product portfolio only includes the basic booking fee (breakfast is included in some of the bookings, but personal charges for meals, laundry, hairdressing, telephone, beverages, alcohol and tobacco, pay TV, baggage handling, postage, etc. are not included in the product price.`,
          },
          {
            id: 1005,
            desc: `Customs tax on baggage entering and leaving the country, and other charges for overweight baggage such as check-in fees and management fees are not included in the price of the product.`,
          },
          {
            id: 1006,
            desc: `Any service fees other than the above mentioned "basic services" are not included in the price of the product. If you need additional items, you need to add the price difference.`,
          },
        ],
      },
    ],
    customizationProcessData: {
      img: pcbg,
      imgM: pcbgn,
      title: {
        name: 'Customization Process',
        desc: '3 simple steps to complete the customization',
      },
      btnText: 'Customize Travel',
      texInfoList: [
        {
          id: 'TEXTINFO101',
          icon: serviceIcon_1,
          children: [
            {
              id: 1001,
              name: 'Free consultation',
            },
            {
              id: 1002,
              name: 'Submit travel requirements, travel consultants will contact you as soon as possible',
            },
          ],
        },
        {
          id: 'TEXTINFO102',
          icon: serviceIcon_2,
          children: [
            {
              id: 1001,
              name: 'Communication itinerary',
            },
            {
              id: 1002,
              name: 'Design your exclusive travel plan, pay the fee after satisfaction',
            },
          ],
        },
        {
          id: 'TEXTINFO103',
          icon: serviceIcon_3,
          children: [
            {
              id: 1001,
              name: 'Booking implementation',
            },
            {
              id: 1002,
              name: 'Complete the booking and make the road book, you can easily travel freely',
            },
          ],
        },
      ],
    },
    faqData: {
      title: 'FAQ',
      list: [
        {
          id: 1001,
          icon: q1,
          title: `Q.What exactly is the difference between Ding Sheng Travel and other custom travel companies?`,
          children: [
            {
              id: 10010,
              desc: `A. All the customizers of Ding Sheng Travel are full-time senior professional customizers who have lived overseas for at least two years and have strict screening and assessment standards. Travel is a very complicated and prudent thing, and we believe that only with full commitment and standardized professionalism can we provide better services.`,
            },
            {
              id: 10021,
              desc: `In addition, the roadmap is what we have been doing since the beginning, and it is always being polished and optimized. Since 2012, every customer has a tailor-made and unique travel book, and we are confident that we are the leader in the industry in terms of the informativeness of the itinerary and the professionalism of the content. As one of the earliest custom travel companies in China, Think Travel has always been committed to providing a warm custom travel service, I believe that once you experience it, you will understand.`,
            },
          ],
        },
        {
          id: 1002,
          icon: q2,
          title: `Q.How do you charge for your services? Is it expensive?`,
          children: [
            {
              id: 10010,
              desc: `A. We will provide you with a real time approved itinerary plan based on your travel needs and budget. With many resource providing partners, as well as professional full-time travel consultants and customizers, we believe that we can provide you with more cost-effective travel products.`,
            },
            {
              id: 10021,
              desc: `In the traditional travel industry, customization has been synonymous with luxury and expensive, but we believe that such a hassle-free, free and cost-effective trip is something that everyone should enjoy. Think Travel is always committed to creating truly affordable, truly frugal custom travel, so that this beautiful thing, travel, back to its rightful appearance.`,
            },
          ],
        },
        {
          id: 1003,
          icon: q3,
          title: 'Q.What will be included in the price of the tour?',
          children: [
            {
              id: 10010,
              desc: `A. For each itinerary, you will see the corresponding price inclusions, roughly speaking, including transportation, sightseeing activities, itinerary design, exclusive road book and all other necessary items for the trip. Of course, we do not exclude some items that are limited by resources and can only be paid by you at the destination, which we will book properly for you, but the cost will not be counted in the price.`,
            },
          ],
        },
        {
          id: 1004,
          icon: q4,
          title: 'Q.Will the customized itinerary really fit my needs perfectly?',
          children: [
            {
              id: 10010,
              desc: `A. From the first time you communicate with us about your travel plans, we will design a tailor-made itinerary based on your needs and preferences, and adjust it during our communication with you. Making every image of the trip, exactly what you want it to be.`,
            },
            {
              id: 10021,
              desc: `We believe that the beauty of customized travel is that everyone can meet the right scenery for themselves during the journey.`,
            },
          ],
        },
        {
          id: 1005,
          icon: q5,
          title: 'Q.Can I arrange a local driver and guide?',
          children: [
            {
              id: 10010,
              desc: `A. The cost of our itineraries does not include the services of a driver and guide, but if you do have a need, we can make alternative arrangements for you. Of course, as a professional custom travel team, we still recommend you to choose the way of free travel with a road book, which is safe and secure, and saves you money, as well as the privacy to experience the fun of exploring deep into the local area and enjoy the real travel.`,
            },
          ],
        },
        {
          id: 1006,
          icon: q6,
          title: 'Q.What kind of people are the tailor-made trips of Ding Sheng Travel suitable for?',
          children: [
            {
              id: 10010,
              desc: `A. In fact, there is no specific division of the population, whether it is honeymoon tour, parent-child tour, family tour, friends gathering tour ... any type of people who want to travel can choose custom travel. And it is especially suitable for people who`,
            },
            {
              id: 10021,
              desc: `No time, no energy to make a strategy, want to save as much effort as possible.`,
            },
            {
              id: 10023,
              desc: `Lack of travel experience / foreign language skills, do not want to travel to leave regrets.`,
            },
            {
              id: 10024,
              desc: `Like to travel freely than with a group, in-depth local, enjoy the real trip.`,
            },
            {
              id: 10025,
              desc: `A lot of attention to travel cost performance.`,
            },
          ],
        },
        {
          id: 1007,
          icon: q7,
          title: 'Q.What is a road book really like? Is there really nothing to worry about when traveling with a road book?',
          children: [
            {
              id: 10010,
              desc: `A. In the road book, the daily itinerary is detailed to the hour, and you will be given detailed instructions and clear tips in English and Chinese at every step, just like a light, knowledgeable guide without compromising your personal space. In addition, we have a 7*24-hour customer travel protection service to keep you safe at all times.`,
            },
            {
              id: 10021,
              desc: `Over the past 5 years, we have served tens of thousands of clients, from elderly people traveling alone, to hearing-impaired couples on their honeymoon, to CCTV hosts and celebrities. All of them have enjoyed the freedom and safety of travel through the "free travel with road book" method.`,
            },
          ],
        },
      ],
    },
    bookingInstructionsData: {
      title: 'Booking Instructions',
      list: [
        {
          id: 1001,
          instruction: {
            icon: basicModal1,
            desc: 'Booking Instructions',
            innerList: [
              {
                key: '100-1',
                subTitle: {
                  desc: `1. You should ensure that the physical condition of the traveler is suitable for the itinerary of the travel product and fill out the Confirmation of Health Condition of Outbound Tourists truthfully.`,
                  children: null,
                },
              },
              {
                key: '100-2',
                subTitle: {
                  type: false,
                  desc: `2. Please make sure you provide accurate and complete information (including but not limited to name, gender, passport information, ID card information, nationality, contact information, whether adult or child, etc.) when booking, in order to avoid making booking errors and affecting the trip. If you provide incorrect personal information, you must bear the economic loss caused by your own.`,
                  children: null,
                },
              },
              {
                key: '100-3',
                subTitle: {
                  type: false,
                  desc: `3. If you need our agency to apply for a visa on your behalf, you should prepare the necessary documents for the visa immediately after confirming the booking order and make sure that the visa documents are delivered to our agency before the deadline given by our agency.`,
                  children: null,
                },
              },
              {
                key: '100-4',
                subTitle: {
                  type: false,
                  desc: `4. During your trip, you should follow the relevant regulations of China and the destination country and region as well as the relevant rules of order in local public places, respect local religious beliefs, national customs and customs, and consciously protect the local natural environment. If you violate the relevant regulations of the People's Republic of China and the destination country (region), you shall be responsible for all consequences arising from carrying excessive currency, goods or prohibited items.`,
                  children: null,
                },
              },
              {
                key: '100-5',
                subTitle: {
                  type: false,
                  desc: `5. The content of this travel product is adjusted frequently with the change of low and high seasons, the product introduction, itinerary, price composition and other related information in the travel service platform of Ding Sheng Travel is for reference only, and the final product content is subject to the confirmation of both parties. `,
                  children: null,
                },
              },
              {
                key: '100-6',
                subTitle: {
                  type: false,
                  desc: `6. The destination accommodation bookings in this product portfolio usually do not include meals unless specifically indicated; if you need meals, please pay at the destination accommodation booking. Please refer to the Accommodation Booking Confirmation for information on destination-specific taxes or fees that may be required to be paid on arrival for the portion of the Destination Accommodation Booking booked in this package.`,
                  children: null,
                },
              },
              {
                key: '100-7',
                subTitle: {
                  type: false,
                  desc: `7. After you decide on the travel product and place an order, we will provide a real-time total travel quote after verification, and we promise to guarantee the validity of the quote for 24 hours from the time it is communicated to you in writing. If you fail to pay the total cost of the trip within the validity period, the quotation will be invalidated and we will need to conduct a second price check.`,
                  children: null,
                },
              },
              {
                key: '100-8',
                subTitle: {
                  type: false,
                  desc: `8. During the peak seasons such as Golden Week and special festivals, the booking of other travel items such as accommodation booking rooms is subject to confirmation of payment and cannot be changed at will once confirmed.`,
                  children: null,
                },
              },
              {
                key: '100-9',
                subTitle: {
                  type: false,
                  desc: `9. If you cancel the trip before the full payment is made, you must bear all the actual losses resulting from the cancellation of the trip and the refund of the tour items in accordance with the "Refund Policy".`,
                  children: null,
                },
              },
              {
                key: '100-10',
                subTitle: {
                  type: false,
                  desc: `10. If you do not travel on time according to the agreed itinerary or if you do not use some of the items in the travel product due to your own reasons, you are considered to have abandoned the use of the product and we will not refund any fees.`,
                  children: null,
                },
              },
              {
                key: '100-11',
                subTitle: {
                  type: false,
                  desc: `11. If it is impossible to perform or continue the trip due to force majeure, our company can, with your consent, change the content of the corresponding trip. If we are unable to consult with you due to emergency or if we are unable to obtain your consent after consultation, we may decide to change the content, but we shall provide the necessary proof of the decision made, and we shall assist you in making a claim to the insurance company for the resulting economic loss.`,
                  children: null,
                },
              },
              {
                key: '100-12',
                subTitle: {
                  type: false,
                  desc: `12. Due to the immigration authorities, consulates, airlines, insurance companies and other authorized institutions can not be attributed to our agency causes you or travelers personal, property rights and interests of damage, including but not limited to flight delays or cancellation, traffic control, passport extension, visa refusal or not issued on time, not allowed to enter or leave the country, you can call our agency in a timely manner, our agency Within the scope of our ability to actively assist, and try to reduce your losses, other matters should be resolved by your own negotiation.`,
                  children: null,
                },
              },
              {
                key: '100-13',
                subTitle: {
                  type: false,
                  desc: `In order to protect your rights, you can call our 24-hour protection telephone number for service matters in the travel products or travel difficulties during the trip. If you have complaints about the services provided by our company during the trip, you can call our company's complaint telephone number to seek solutions.`,
                  children: null,
                },
              },
            ],
          },
        },
        {
          id: 1002,
          instruction: {
            icon: basicModal1,
            desc: 'Refund and Change Rules',
            innerList: [
              {
                key: '100-1',
                subTitle: {
                  type: false,
                  desc: `1. Incurred and non-refundable costs: refers to the costs you have incurred for the purchase of travel products and the non-refundable fees and charges paid to the performance support person (such as accommodation booking, catering, transportation, tourist attraction service provider).`,
                  children: null,
                },
              },
              {
                key: '100-2',
                subTitle: {
                  type: false,
                  desc: `2. The booking of international air tickets included in the travel products shall be carried out in accordance with the refund and change rules of the air ticket booking confirmation.`,
                  children: null,
                },
              },
              {
                key: '100-3',
                subTitle: {
                  type: false,
                  desc: `3. If you need to modify the final subject tour product (including plus package) for reasons other than our company, after you have made full payment, you may request changes to specific travel elements (meaning specific accommodation reservations, attractions, activities, transportation, etc.). You will be responsible for any increase in travel expenses caused by the change of travel elements; any increase, deletion, replacement or change of order of travel elements will be regarded as a change. We will give you the preferential service of changing [2] free of charge, and you shall pay the service fee to us at the rate of RMB150/item for the excess (if you have already enjoyed the preferential service, you shall not enjoy it).`,
                  children: null,
                },
              },
              {
                key: '100-4',
                subTitle: {
                  type: false,
                  desc: `4. You may transfer your rights and obligations in this product to a third party before the start of the travel itinerary, and our agency shall not refuse without justifiable reasons (justifiable reasons include but are not limited to: the travel items already booked are not transferable or refundable, and the travel items have special requirements on the identity, qualification and physical condition of the traveler, etc.), and the increased costs as a result shall be borne by you and the third party.`,
                  children: null,
                },
              },
              {
                key: '100-5',
                subTitle: {
                  type: false,
                  desc: `5. If you propose to change the travel destination country after you have paid the deposit and our company has provided the travel plan, you need to pay the service fee to our company according to RMB500/time; if you propose to change the travel destination country after you have paid the full amount, it is regarded as the new travel plan and you need to sign a separate contract to pay the fee.`,
                  children: null,
                },
              },
              {
                key: '100-6',
                subTitle: {
                  type: false,
                  desc: `6. You may request changes in the content of the travel elements of the travel products provided by our company, but you may not request individual refunds for some of the items.`,
                  children: null,
                },
              },
              {
                key: '100-7',
                subTitle: {
                  type: true,
                  desc: '7. You cancel the contract.',
                  children: [
                    {
                      key: '100-7-1',
                      type: true,
                      desc: `(1). If you propose to cancel the contract before the start of the trip, or if we cancel the contract before the start of the trip as agreed in Article 10.2, Paragraph 1 of the Travel Contract, if you have paid part of the travel expenses or the full amount, we shall deduct the incurred and non-refundable expenses and deduct the liquidated damages in accordance with the following standards.`,
                      children: [
                        {
                          type: true,
                          desc: `A. If the cancellation time (before the travel date) is 45 days (including 45 days) or more, a liquidated damages of 10% of the total travel expenses shall be paid.`,
                        },
                        {
                          type: true,
                          desc: `B. 45-30 days (including 30 days) before the time of cancellation (travel date), 15% of the total trip cost as liquidated damages.`,
                        },
                        {
                          type: true,
                          desc: `C. 30-15 days (inclusive) before the time of cancellation (travel date), 20% of the total amount of travel expenses in liquidated damages.`,
                        },
                        {
                          type: true,
                          desc: `D. Within 15 days of the time of cancellation (before the date of travel), 30% of the total amount of travel expenses in liquidated damages.`,
                        },
                      ],
                    },
                    {
                      key: '100-7-2',
                      type: true,
                      desc: `(2). If you cancel the contract during the trip, our company shall deduct the incurred and non-refundable expenses, and you shall pay liquidated damages in accordance with the following liquidated damages calculation method.`,
                      children: [
                        {
                          type: true,
                          desc: `Liquidated damages = total travel expenses × 30% + (total travel expenses - total travel expenses × 30%) ÷ total number of travel days × number of days already traveled`,
                        },
                      ],
                    },
                    {
                      key: '100-7-3',
                      type: true,
                      desc: `(3). If you do not arrive at the agreed meeting point at the agreed time, and are unable to participate in the tour normally, you are deemed to have cancelled the contract; if you do not use all the rooms booked on behalf of the airline or accommodation due to your own reasons, you are deemed to have abandoned the use and cancelled the contract. All losses or disputes arising therefrom shall be borne by you.`,
                    },
                  ],
                },
              },
              {
                key: '100-8',
                subTitle: {
                  type: true,
                  desc: '8. Cancellation of the contract by our company.',
                  children: [
                    {
                      key: '100-8-1',
                      type: true,
                      desc: `(1). If you have one of the following circumstances, our company can cancel the travel contract.`,
                      children: [
                        {
                          type: true,
                          desc: `A. suffer from infectious diseases and other diseases that may endanger the health and safety of other travelers.`,
                        },
                        {
                          type: true,
                          desc: `B. Carrying articles that endanger public safety and do not agree to hand them over to the relevant authorities.`,
                        },
                        {
                          type: true,
                          desc: `C. Engaging in activities that are illegal or contrary to social morality.`,
                        },
                        {
                          type: true,
                          desc: `D. Engaged in activities that seriously affect the rights and interests of other travelers, and who do not listen to advice and cannot be stopped.`,
                        },
                        {
                          type: true,
                          desc: `E. Other circumstances that affect the performance of the contract as stipulated by law.`,
                        },
                      ],
                    },
                    {
                      key: '100-8-2',
                      type: true,
                      desc: `(2). If our agency proposes to cancel the contract before the start of the trip (excluding the circumstances agreed in Article 10.2, paragraph 1 of the travel contract), our agency shall refund all your travel expenses and pay you liquidated damages in accordance with the following standards.`,
                      children: [
                        {
                          type: true,
                          desc: `A. 45 days (including 45 days) or more before the cancellation time (before the travel date), a liquidated damages of 10% of the total travel expenses.`,
                        },
                        {
                          type: true,
                          desc: `B. 45-30 days (including 30 days) before the time of cancellation (travel date), a liquidated damages of 15% of the total amount of travel expenses.`,
                        },
                        {
                          type: true,
                          desc: `C. 30-15 days (inclusive) before the time of cancellation (travel date), 20% of the total amount of travel expenses in liquidated damages.`,
                        },
                        {
                          type: true,
                          desc: `D. Within 15 days of the time of cancellation (before the travel date), 30% of the total travel cost in liquidated damages.`,
                        },
                      ],
                    },
                  ],
                },
              },
              {
                key: '100-9',
                subTitle: {
                  type: true,
                  desc: `* Visa Refusal Protection Plan`,
                  children: [
                    {
                      key: '100-9-1',
                      type: true,
                      desc: `1. "Visa Refusal Protection Plan" means that you entrust our agency to apply for a visa on your behalf while purchasing our visa refusal protection service (RMB 200 yuan / person / country, Schengen country visa is considered a country), if you are unable to travel due to visa refusal by the embassy or consulate of the destination country, all of its If you are unable to travel due to visa refusal by the embassy or consulate of the destination country, all travel expenses paid (excluding non-refundable items) will be refundable. 2.`,
                      children: null,
                    },
                    {
                      key: '100-9-2',
                      type: true,
                      desc: `2. Time limit of coverage: from 00:00:00 on the day following your purchase of our visa refusal protection service to 23:59:59 on the day before your actual travel.`,
                      children: null,
                    },
                    {
                      key: '100-9-3',
                      type: true,
                      desc: `3. Coverage category: "Visa Refusal Protection Plan" is only applicable to tourist visa applications.`,
                      children: null,
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },

  },
  customTravel: {
    bannerData: {
      img: customizedtravel,
      imgM: customizedtravelm,
      customTravel: 'Customized Travel',
      startCustomizing: 'Start Customizing',
      tailorMade: {
        title: 'Tailor-Made Travel Solutions',
        desc: `All itineraries can be exclusively customized according to the number of people, time, budget and interests of your trip, and  Ding Sheng Travel's travel customizers will provide you with one-on-one itinerary customization services.`,
      }
    },
    pointersContentData: [
      {
        no: '01',
        img: ct_image01,
        title: 'You Decide The Time',
        desc: `No need to bother with strategy You only need to decide to send All the rest is left to us.`,

      },
      {
        no: '02',
        img: ct_image02,
        title: 'You Decide How To Play',
        desc: `Travel alone or with friends and family. Or a short holiday, or a polar adventure. No group, only freedom You decide.`,
      },
      {
        no: '03',
        img: ct_image03,
        title: 'You Set The Pace',
        desc: `You can sleep until you wake up Or you can walk all day The pace is at your disposal, stop and go as you like.`,
      },
    ],
    chooseData: {
      title: 'Why Choose  Ding Sheng Travel?',
      desc: 'Eight services, all-inclusive',
      list: [
        {
          id: 1001,
          text: 'Air Ticket Booking',
          icon: frame_1,
        },
        {
          id: 1002,
          text: 'Accommodation Booking',
          icon: frame_2,
        },
        {
          id: 1003,
          text: 'Itinerary Design',
          icon: frame_3,
        },
        {
          id: 1004,
          text: 'Exclusive Road Map',
          icon: frame_4,
        },
        {
          id: 1005,
          text: 'Travel Visa',
          icon: frame_5,
        },
        {
          id: 1006,
          text: 'Travel Insurance',
          icon: frame_6,
        },
        {
          id: 1007,
          text: 'Travel WIFI',
          icon: frame_7,
        },
        {
          id: 1008,
          text: 'Golden Car Guide',
          icon: frame_8,
        },
      ],
    },
    pointersData: {
      img: whychoose_bg,
      imgM: whychoose_bgm,
      list: [
        {
          key: '101',
          title: 'True Customization',
          desc: 'Time, pace, play, you decide',
        },
        {
          key: '102',
          title: 'All-Inclusive',
          desc: `We'll take care of all the details, including flights, wine, tips and visas`,
        },
        {
          key: '103',
          title: 'Guaranteed',
          desc: `Route field survey, exclusive butler on call`,
        },
      ]
    },
    serviceFlowData: {
      title: 'Service Flow',
      list: [
        {
          id: 1001,
          icon: customtravelIcon1,
          title: 'Free Consultation',
          desc: `Contact customer service and submit your travel needs`,
          style: {
            width: '270px'
          },
        },
        {
          id: 1002,
          icon: customtravelIcon2,
          title: 'Itinerary Design',
          desc: `Customized engineer to design your travel plan, satisfied with the contract payment`,
          style: {
            width: '290px'
          },
        },
        {
          id: 1003,
          icon: customtravelIcon3,
          title: 'Happy Travel',
          desc: `Make a road map, embark on the journey`,
          style: {
            width: 'auto'
          },
        },
        {
          id: 1004,
          icon: customtravelIcon4,
          title: 'Full Protection',
          desc: `Million travel insurance, 7×24 butler service`,
          style: {
            width: '200px'
          },
        },
      ],
    },
  },
  aboutUs: {
    travelWorldEnjoyWhatData: {
      title: 'Travel the World and Enjoy What you Want',
      list: [
        {
          id: 1001,
          text: `Established in 2016, ${companyName.fullNameEN}, Ltd. is a professional and comprehensive travel service provider in China. We promote a different vacation concept, providing services including inbound tours, outbound tours, travel customization, hotel booking and other services, travel services. We have a strong competitive advantage in Hong Kong and Macao tours, Southeast Asia outbound tours, Japan and Korea outbound tours, and have been winning praise from customers at home and abroad for our excellent travel quality and honest services.`,
        },
        {
          id: 1001,
          text: `Up to now, Ding Sheng Travel has travel products covering more than 120 countries and regions around the world, serving different people, and even launched nearly 100 high quality travel routes for high net worth people, providing three-dimensional and multi-channel services for travel consumers. Our team has visited 42 countries around the world and collected unique resources, and has provided private customized travel services for thousands of people and families.`,
        },
      ],
      info: {
        imgList: [au_image02, au_image01],
        desc: `In the future, we will continue to adhere to the business philosophy of "customer needs first, focus on quality tourism", with a deep brand foundation and mature business advantages, fully explore tourism resources to provide quality services for domestic and foreign tourists, develop a new tourism product matrix more in line with market demand, to become a leading scale, excellent quality integrated tourism We will become a comprehensive tourism service provider with leading scale and excellent quality. With high quality cultural tourism products and services, enthusiastic attitude and professional services, we will bring tourists a satisfactory and comfortable travel experience.`,
      }
    },
    businessPhilosophyData: {
      img: philosophy_img,
      imgM: philosophy_imgm,
      title: 'Business Philosophy',
      desc: `Customer Needs First, Insist On Quality Service`,
    }
  },
  layouts: {
    headerData: {
      navLinkList: [
        {
          id: 1001,
          title: 'Customized Travel',
        },
        {
          id: 1002,
          title: 'FAQ',
        },
        {
          id: 1003,
          title: 'Booking Instructions',
        },
      ],
    },
    footerData: {
      backToTitle: 'TOP',
      
      websiteRecord: websiteRecord.websiteRecordEN, // 备案->中文
      copyright: websiteRecord.copyrightEN, // 版权->中文
      companyFullName: companyName.fullNameEN, // 全称->中文,
      abbreviation: abbreviation.abbreviationEN, // 简称->中文
      companyAddress: companyAddress.addressEN, // 公司地址->中文
      csh: `24x7 Customer Service Hotline：`,
      tel: contactInformation.tel, // 联系方式
    }
  },
  serverGroupData: {
    list: [
      {
        id: 1001,
        title: 'Freedom',
        desc: 'No need to follow group',
        icon: icon1,
        iconm: iconm1,
      },
      {
        id: 1002,
        title: 'Insured',
        desc: '24/7 hours',
        icon: icon2,
        iconm: iconm2,
      },
      {
        id: 1003,
        title: 'Worry Free',
        desc: `Don't do strategy`,
        icon: icon3,
        iconm: iconm3,
      },
    ]
  },
  planTravel: {
    findCaseYouLink: {
      titleOne: `Didn't Find a Case you Like?`,
      titleTwo: 'Start Customizing',
      desc: `Why not try submitting a request form and a customizer will create your own proposal for free!`,
      links: [
        {
          tabTitle: 'Choose the destination you want to go to',
        },
        {
          tabTitle: 'Choose the destination you want to go to',
        },
        {
          tabTitle: 'Let us know your travel preferences',
        },
        {
          tabTitle: 'Anything else?',
        },
      ]
    },
    domesticTitle: 'Domestic',
    overseasTitle: 'Overseas',
    contactTitle: 'Contact',
  },
  customProcessSteps: {
    stepsOne: {
      // 目的地
      destination: {
        // 国内
        domestic: {
          name: 'Destination',
          placeholder: 'Fill in destination',
          list: [
            {
              id: 1001,
              title: 'Sichuan',
            },
            {
              id: 1002,
              title: 'Hunan',
            },
            {
              id: 1003,
              title: 'Chongqing',
            },
            {
              id: 1004,
              title: 'Hubei',
            },
            {
              id: 1005,
              title: 'Hebei',
            },
            {
              id: 1006,
              title: 'Sanya',
            },
            {
              id: 1007,
              title: 'Yunnan',
            },
          ]
        },
        // 境外
        overseas: {
          content: {
            name: 'Destination',
            placeholder: 'Fill in destination',
          },
          list: [
            {
              id: 1001,
              title: 'Bangkok',
            },
            {
              id: 1002,
              title: 'Phuket',
            },
            {
              id: 1003,
              title: 'Bali',
            },
            {
              id: 1004,
              title: 'Tokyo',
            },
            {
              id: 1005,
              title: 'Hokkaido',
            },
            {
              id: 1006,
              title: 'Seoul',
            },
            {
              id: 1007,
              title: 'Paris',
            },
            {
              id: 1008,
              title: 'Cairo',
            },
            {
              id: 1009,
              title: 'Venice',
            },
            {
              id: 1010,
              title: 'Sydney',
            },
            {
              id: 1011,
              title: 'Moscow',
            },
            {
              id: 1012,
              title: 'London',
            },
          ]
        },
        // 请选择目的地
        message: '*Please select/fill in a destination',
      },
      // 天娄
      noOfDays: {
        content: {
          name: 'No. of Days',
        },
        list: [
          {
            id: 1001,
            title: '1 Day',
          },
          {
            id: 1002,
            title: '2-4 Days',
          },
          {
            id: 1003,
            title: '5-7Days',
          },
          {
            id: 1004,
            title: '< 7days',
          },
        ],
        message: '* Please select no. of days',
      },
      // 人娄
      noOfPax: {
        content: {
          name: 'No. of Pax',
        },
      },
      // 出发日期
      departureDate: {
        content: {
          title: 'Date',
          placeholder: 'Choose a date',
        },
        message: '* Please select the departure date',
      }
    },
    stepsTwo: {
      travelRequest: {
        content: {
          title: 'Travel Request',
          placeholder: 'Type something',
        },
      },
      travelName: {
        content: {
          title: 'Name',
          placeholder: 'Enter name',
        },
        message: '*Name cannot be empty',
      },
      mobile: {
        content: {
          title: 'Mobile',
          placeholder: 'Enter mobile number',
        },
        messages: {
          title: '* Phone number cannot be empty',
          msg: '* Please fill in the correct phone number',
        },
      },
    },
    stepsThree: {
      content: {
        title: 'Submitted Successfully!',
        titleSub: `We have received your inquiryA travel consultant will be in touch with you within 30 minutes.`,
      },
    },
  }
};
export default enUS;
